import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { LayoutSingleColumn, NamedLink, Page, PrimaryButton } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import Icons from '../../components/Icons/Icons';
import SectionFAQ from './SectionFAQ';
import SectionBlogs from './SectionBlogs';
import bannerVideo from '../../assets/bannerVideo.mp4';
import { DreamHomePageTab, StrapiUserTypePages } from '../../util/enums';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';
import { useDispatch } from 'react-redux';
import { fetchAllBlogs, fetchAllFaqs } from '../../ducks/strapi.duck';
import css from './CustomerLandingPage.module.css';
import OffsiteConstruction from './OffsiteConstruction/OffsiteConstruction';

const CustomerLandingPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllBlogs({ pageType: StrapiUserTypePages.CUSTOMER_LANDING_PAGE }));
    dispatch(fetchAllFaqs({ pageType: StrapiUserTypePages.CUSTOMER_LANDING_PAGE }));
  }, []);

  const onRedirectToPage = (page, params = {}, search = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration(), params, search));
  };

  return (
    <Page title={intl.formatMessage({ id: 'CustomerLandingPage.title' })} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="AboutUsPage" type="floating" />}
        footer={<FooterContainer />}
      >
        <div className={css.aboutWorkSec}>
          <div className={css.fixedWidthContainer}>
            <center className={css.mainTitle}>
              <h2>{intl.formatMessage({ id: 'CustomerLandingPage.Heading' })}</h2>
            </center>
            <div className={css.ourWorkSec}>
              {[1, 2, 3, 4].map(num => (
                <div className={css.workBlock} key={num}>
                  <Icons name={['work', 'uploadFile', 'supplier', 'connect'][num - 1]} />
                  <h2>{intl.formatMessage({ id: `CustomerLandingPage.Step${num}.Title` })}</h2>
                  <p>{intl.formatMessage({ id: `CustomerLandingPage.Step${num}.Description` })}</p>
                </div>
              ))}
            </div>
            <p>
              {intl.formatMessage({ id: 'CustomerLandingPage.ProjectBrief.CTA' })}&nbsp;
              <NamedLink
                name="DreamHomePage"
                params={{ tab: DreamHomePageTab.PLOT_DETAILS }}
                className={css.getStarted}
              >
                {intl.formatMessage({ id: 'CustomerLandingPage.ProjectBrief.Button' })}{' '}
                <Icons name="rightArrow" />
              </NamedLink>
            </p>
          </div>
        </div>

        <div className={css.offsiteConstruction}>
          <div className={css.fixedWidthContainer}>
            {/* <div className={css.mainTitle}>
              <h2>{intl.formatMessage({ id: 'CustomerLandingPage.Offsite.Title' })}</h2>
              <p>
                {intl.formatMessage({ id: 'CustomerLandingPage.Offsite.Description' })}&nbsp;
                <NamedLink className={css.learnMore} name="CustomOffsiteConstructionPage">
                  {intl.formatMessage({ id: 'CustomerLandingPage.Offsite.LearnMore' })}{' '}
                  <Icons name="rightArrow" />
                </NamedLink>
              </p>
            </div> */}
            <div className={css.timelineSec}>
              {/* <h4>{intl.formatMessage({ id: 'CustomerLandingPage.Timeline.Title' })}</h4> */}

              <OffsiteConstruction intl={intl} />
              {/* <div className={css.startCheck}>
                {[
                  'AffordabilityCheck',
                  'LandAcquisition',
                  'DesignPlanning',
                  'BuildingRegulations',
                  'ContractorPricing',
                  'SitePrep',
                  'FactoryAssemble',
                  'InstallFactoryHouse',
                  'FinishesLandscaping',
                ].map((step, i) => (
                  <div key={i} className={css.checkStep}>
                    <h2>
                      {intl.formatMessage({ id: `CustomerLandingPage.Offsite.${step}.Title` })}
                    </h2>
                    {intl.messages[`CustomerLandingPage.Offsite.${step}.Description`] && (
                      <p>
                        {intl.formatMessage({
                          id: `CustomerLandingPage.Offsite.${step}.Description`,
                        })}
                      </p>
                    )}
                  </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>

        <SectionBlogs />
        <SectionFAQ intl={intl} />

        <div className={css.ctaSec}>
          <div className={css.contentWidth}>
            <div className={css.mainTitle}>
              <h2>{intl.formatMessage({ id: 'CustomerLandingPage.CTA.Title' })}</h2>
              <PrimaryButton
                className={css.getstartbtn}
                type="button"
                onClick={() =>
                  onRedirectToPage('DreamHomePage', { tab: DreamHomePageTab.PLOT_DETAILS })
                }
              >
                {intl.formatMessage({ id: 'CustomerLandingPage.CTA.Button' })}
              </PrimaryButton>
            </div>
          </div>
        </div>

        <div className={css.videoSec}>
          <div className={css.fixedWidthContainer}>
            <video className={css.video} src={bannerVideo} controls autoPlay muted loop />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default CustomerLandingPage;
